export default __webpack_public_path__ + "static/media/bc36fe1acfdb7ea3c885477ef74025c6.png";